import { Chess } from "@chesshotel/chess";
import { exchangeEvaluation } from "./util.js";
export function detectTrappedPiece(fen, square) {
    let chess = new Chess(fen);
    const moves = chess.moves({
        square: square,
        legal: true,
        verbose: true,
    });
    moves.forEach((move) => {
        if (move.captured) {
            const evaluation = exchangeEvaluation(chess.fen(), move.to, {
                from: move.from,
                backtrackBadMoves: true,
            });
            if (evaluation.gain >= 0) {
                return false;
            }
        }
        else {
            chess.load(fen);
            chess.move(move);
            const moveFen = chess.fen();
            const evaluation = exchangeEvaluation(moveFen, move.to, {
                backtrackBadMoves: true,
            });
            if (evaluation.gain <= 0) {
                return false;
            }
        }
    });
    if (chess.inCheck()) {
        const moves = chess.moves({
            square: square,
            legal: true,
            verbose: true,
        });
        if (moves.length > 0) {
            chess.move(moves[0]);
        }
    }
    else {
        chess.changeTurn();
    }
    const evaluation = exchangeEvaluation(chess.fen(), square, {
        backtrackBadMoves: true,
    });
    if (evaluation.gain <= 0) {
        return false;
    }
    return true;
}
//# sourceMappingURL=trappedPiece.js.map